/* import __COLOCATED_TEMPLATE__ from './survey-dropdown-question-editor.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
/* eslint-disable @intercom/intercom/no-component-inheritance */
import BaseEditor from './base-editor';
export default BaseEditor.extend({
  get dropdownOptions() {
    return this.predicateContext.branchingPredicateDataContext;
  },
  get selectedValue() {
    let allOptions = this.predicateContext.branchingPredicateDataContext.map(option => option.value);
    let optionsHavePredicate = allOptions.includes(this.predicate.value);
    if (!optionsHavePredicate) {
      return undefined;
    }
    return this.predicate.value;
  },
  get selectLabel() {
    return this.selectedValue ? undefined : 'Select an option';
  }
});